<template>
  <div  class="w-100 looks">
    <LookMenu/>
    <div v-if="cargando" class="cargando">
            <v-progress-circular
            indeterminate
            color="#2562a4"
          ></v-progress-circular>
    </div>
    <div id="looks" v-else class="w-100 pt-5">
      <transition name="filtro">
        <LookFiltro v-show="$store.getters.isFiltroLooksOpen"/>
      </transition>
      <div class="pb-5 mt-2 d-flex flex-wrap" :class = "($store.getters.isFiltroLooksOpen)?'go-right':'go-left'" >
        <div
          v-for="n in looks"
          :key="n.mslId"
          class="d-flex card-container"
        >
          <v-hover>
            <v-card 
              flat 
              tile
              outlined
              slot-scope="{ hover }"
              class="float-buttons mt-3 d-flex column mx-2"
              :class="`elevation-${hover ? 5 : 2} my-2 d-flex flex-column`"
              >
              <v-img
                  @click="verLook(n.mslId)"
                  :src="'data:image/jpeg;base64,' + n.mslImagen"
                  :lazy-src="require('@/assets/images/noimg.jpg')"
                  aspect-ratio="1"
                  contain
                >
                <v-btn flat class=" primary">
                  <v-icon class="mr-2">visibility</v-icon>
                  Ver look
                </v-btn>
              </v-img>
              <v-divider class="mt-0"></v-divider>
                  <v-card-title class="text-uppercase primary-color mb-0 pb-0 mt-0 font-weight-bold title">
                    {{n.mslTitulo}}
                  </v-card-title>
                  <v-card-text class="py-0 h6 my-0 pb-3 text-uppercase">
                    {{n.mslDesc}}
                  </v-card-text> 
                 <v-btn text v-if="permitido('MOBILESTORE.LOOKS.CRUD')" @click="editarLook(n.mslId)" class="orange white--text" flat absolute top right dark icon ><v-icon>edit</v-icon></v-btn>
                <v-btn v-if="permitido('MOBILESTORE.LOOKS.CRUD')" @click.prevent="deleteLook(n.mslId)" class="primary" flat absolute top right dark icon><v-icon>delete</v-icon></v-btn>
            </v-card>
          </v-hover>
        </div>
      </div>
      <div v-if="looks.length === 0">
        <v-alert
          :value="true"
          color="primary"
          class="mx-5 primary-color"
          outline
          ><v-icon class="mr-2">search_off</v-icon>No hay looks
          </v-alert>
      </div>
    </div>
  </div>
</template>
<script>
import LookFiltro from './components/menu/LookFiltro'
import { LookApiService } from '@/api/LookApiService'

const lookApiService = new LookApiService()

import LookMenu from './components/menu/LookMenu.vue'

export default {
  name: "Looks",
  components: {
    LookMenu,
    LookFiltro
  },
  data () {
    return {
      looks: [],
      cargando: false,
    }
  },
  computed: {
    hasLookSearched () {
      return this.$store.state.userInfo.hasLookSearched;
    },
  },
  watch: {
    hasLookSearched (value) {
      this.init();
    }
  },
  mounted () {
    this.init()
    this.cambioTitulo()
  },
  methods: {
    init () {
      if (this.$store.state.userInfo.hasLookSearched !== 0) {
         this.getLooksBy() 
      } else {
        this.getAllLooks()
      }
    },
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">checkroom</v-icon>`
      this.$store.state.titulo = "Administrar looks"
    },
    getAllLooks() {
      this.cargando = true
      lookApiService.getAllLooks()
        .then(data => {
          this.cargando = false
          this.looks = data
        })
        .catch(error => {
          console.log(error) 
          this.cargando = false
        })
    },
    getLooksBy() {
      let filtro = {
        localizador : this.$store.state.userInfo.lookLocalizadorSearched,
        nombre : this.$store.state.userInfo.lookNombreSearched,
        validado : this.$store.state.userInfo.lookValidadoSearched
      }
      lookApiService.getLooksBy(filtro)
        .then (data => {
          this.looks = data
        })
        .catch (error => {
          console.log(error)
        })
    },
    deleteLook(id) {
      this.$root.$confirm.open('Borrar', '¿Deseas borrar el look?', { color: 'primary' }).then((confirm) => {
        if (confirm) {
          lookApiService.deleteLook(id)
            .then(data => {
              if (data) {
                this.init()
              } else {
                console.log('Error en borrado')
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    editarLook(id) {
      this.$router.push({ name:'lookcreator', params: { lookid: id }})
    },
    verLook(id) {
      this.$router.push({ name:'lookviewer', params: { lookid: id }})
    }
  }
}
</script>